module.exports = __webpack_public_path__ + "static/media/gmad-logobranca.ead7c819.svg";